export default __webpack_public_path__ + "static/media/item1.fcb67eef.jpeg";